import * as React from 'react'
import { bind } from 'classnames/bind'
import * as styles from '@procore/core-css/src/layouts/_flex.scss'

import { SizeNS, DivAttributes } from '../utils/types'
import Box, { FlexDirection, FlexDirectionNS, MarginSize } from './Box'
import Flex, { FlexProps } from './Flex'

const cx = bind(styles)

const getSingleSize = (size: string = ''): MarginSize => {
  return size.split(' ')[0] as MarginSize
}

const getChildMargin = (direction: FlexDirection, size: MarginSize): string =>
  [FlexDirectionNS.row, FlexDirectionNS.rowReverse].indexOf(direction) >= 0
    ? `${SizeNS.none} ${size}`
    : `${size} ${SizeNS.none}`

interface FlexListProps extends FlexProps {
  size?: MarginSize
}

const FlexList = React.forwardRef<
  HTMLDivElement,
  DivAttributes & FlexListProps
>(
  (
    {
      children,
      direction = FlexDirectionNS.row,
      size = SizeNS.md,
      className,
      ...props
    },
    ref
  ) => {
    return (
      <Flex
        ref={ref}
        direction={direction}
        className={cx('core-flexlist', className)}
        {...props}
      >
        {React.Children.toArray(children)
          .filter(child => child)
          .map(
            (child: any, i) =>
              child && (
                <Box
                  key={child.key || i}
                  margin={getChildMargin(direction, getSingleSize(size))}
                >
                  {child}
                </Box>
              )
          )}
      </Flex>
    )
  }
)

FlexList.displayName = 'FlexList'

export default FlexList
